import { createContext, useCallback, useContext, useEffect, useState } from "react"
import { Snackbar, Typography, Box, Button } from '@material-ui/core';
import ButtonWithIcon from "../../components/controls/ButtonWithIcon";

const AppUpdateContext = createContext();

export const AppUpdateProvider = ({ children }) => {

    const [open, setOpen] = useState(false); // El snackbar empieza cerrado

    const searchForUpdates = useCallback(() => {
        const appNeedUpdate = sessionStorage.getItem('app-need-update');
        if (appNeedUpdate && JSON.parse(appNeedUpdate) === true) {
            setOpen(true)
        }
    }, [])

    useEffect(() => {
        if (!open) {
            searchForUpdates() // Abre el modal si no está abierto
        }
    }, []);


    useEffect(() => {
        const interval = setInterval(() => {
            if (!open) {
                searchForUpdates() // Abre el modal si no está abierto
            }
        }, 300000); // Cada 5 minutos intenta abrir el modal

        return () => clearInterval(interval); // Limpia el intervalo al desmontar
    }, [open]);

    const handleClose = () => {
        setOpen(false)
    }

    const handleUpdate = () => {
        sessionStorage.setItem('app-need-update', JSON.stringify(false));
        setOpen(false);
        window.location.reload();
    };

    return (
        <AppUpdateContext.Provider value={searchForUpdates}>
            {children}
            <Snackbar
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                ContentProps={{
                    style: {
                        background: '#222',
                        color: '#fff',
                        borderRadius: 12,
                        minWidth: 340,
                        boxShadow: '0 2px 12px rgba(0,0,0,0.2)'
                    }
                }}
                message={
                    <Box>
                        <Typography variant="h6" style={{ fontWeight: 600, color: '#fff' }}>
                            Nueva Versión Disponible
                        </Typography>
                        <Typography variant="body2" style={{ fontSize: '12px', color: '#fff' }}>
                            Hay una nueva versión del sitio web. ¿Quieres actualizar ahora?
                        </Typography>
                    </Box>
                }
                action={
                    <>
                        <Button color="primary" size="small" onClick={handleClose} style={{ fontWeight: 600, color: '#fff' }}>
                            Más tarde
                        </Button>
                        <Button color="secondary" size="small" onClick={handleUpdate} style={{ fontWeight: 600, color: '#fff' }}>
                            Actualizar
                        </Button>
                    </>
                }
            />
        </AppUpdateContext.Provider>
    )
}

export const useAppUdate = () => {
    return useContext(AppUpdateContext);
};
